var antPrefixCls = '.ant-tree-select';

// const genDropdownStyle: GenerateStyle<TreeSelectToken> = token => {
//   const antSelectPrefixCls = '.ant-select';
//   const antPrefixCls = '.ant-tree-select';

//   return [
//     {
//       [`${antPrefixCls}-dropdown`]: {
//         [`${antSelectPrefixCls}-tree-treenode`]: {
//           width: '100%',
//           [`${antSelectPrefixCls}-tree-switcher`]: {
//             width: '20px',
//           },
//           [`${antSelectPrefixCls}-tree-node-content-wrapper`]: {
//             padding: `0 8px`,
//           },
//           [`&:hover:not(&-disabled):not(&${antSelectPrefixCls}-tree-treenode-selected)`]: {
//             [`${antSelectPrefixCls}-tree-node-content-wrapper`]: {
//               backgroundColor: token.itemBackgroundHoverColor,
//               color: `${token.itemHoverColor} !important`,
//             },
//           },
//           [`&${antSelectPrefixCls}-tree-treenode-selected`]: {
//             [`${antSelectPrefixCls}-tree-node-content-wrapper`]: {
//               backgroundColor: token.colorPrimaryBg,
//               color: token.colorPrimaryText,
//             },
//           },
//           [`&${antSelectPrefixCls}-tree-treenode-disabled`]: {
//             [`${antSelectPrefixCls}-tree-node-content-wrapper`]: {
//               color: token.colorTextDisabled,
//             },
//           },
//         },
//       },
//     },
//   ];
// };

var genBaseStyle = function genBaseStyle(token) {
  var _ref;
  return [(_ref = {}, _ref[antPrefixCls] = {}, _ref['.ant-tree-select-dropdown'] = {
    '.ant-select-tree': {
      '.ant-select-tree-node-content-wrapper,.ant-select-tree-checkbox+span': {
        borderRadius: 0
      },
      '.ant-select-tree-switcher': {
        marginInlineEnd: 0
      },
      '.ant-select-tree-switcher-icon': {
        position: 'relative'
      },
      '.ant-select-tree-node-content-wrapper': {
        paddingInline: 4
      },
      '.ant-select-tree-node-selected,.ant-select-tree-treenode-checkbox-checked': {
        fontWeight: 500
      }
    }
  }, _ref)];
};

// ============================== Export ==============================
var treeSelectStyleFn = function treeSelectStyleFn(treeSelectToken) {
  return [genBaseStyle()];
};

export { treeSelectStyleFn };
